import { types as t } from 'mobx-state-tree';


const Ad = t.model("Ad", {
	Text: t.string,
	Colour: t.string,
}).views(self => ({

})).actions(self => ({

}));


export default Ad;